import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { ISaveDraftJobPostPayload } from '../types';

export const saveDraftJobPost = async (
  id: string,
  data: ISaveDraftJobPostPayload,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.patch(`/posting-service/postings/${id}`, data, { headers });
};
